import React from 'react';

export default function NotFound() {
  return (
    <div className='flex justify-center items-center h-screen'>
      <div>Not Found This Page 🤔</div>
    </div>
  );
}

